/**
 * Traffic Lights Component
 *
 * macOS-style window control buttons (close, minimize, maximize).
 * Shows icons on hover, triggers callbacks on click.
 */

import { useState } from 'react'

export interface TrafficLightsProps {
  onClose?: () => void
  onMinimize?: () => void
  onMaximize?: () => void
  disabled?: boolean
  className?: string
}

export function TrafficLights({
  onClose,
  onMinimize,
  onMaximize,
  disabled = false,
  className = '',
}: TrafficLightsProps) {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div
      className={`mac-traffic-lights ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button
        type="button"
        className="mac-traffic-light mac-traffic-light--red"
        onClick={onClose}
        disabled={disabled}
        aria-label="Close window"
      >
        <span className="mac-traffic-light__icon">
          {isHovered && '×'}
        </span>
      </button>

      <button
        type="button"
        className="mac-traffic-light mac-traffic-light--yellow"
        onClick={onMinimize}
        disabled={disabled}
        aria-label="Minimize window"
      >
        <span className="mac-traffic-light__icon">
          {isHovered && '−'}
        </span>
      </button>

      <button
        type="button"
        className="mac-traffic-light mac-traffic-light--green"
        onClick={onMaximize}
        disabled={disabled}
        aria-label="Maximize window"
      >
        <span className="mac-traffic-light__icon">
          {isHovered && '+'}
        </span>
      </button>
    </div>
  )
}
